import { render, staticRenderFns } from "./jianyi.vue?vue&type=template&id=a830d2dc&scoped=true&"
import script from "./jianyi.vue?vue&type=script&lang=js&"
export * from "./jianyi.vue?vue&type=script&lang=js&"
import style0 from "./jianyi.vue?vue&type=style&index=0&id=a830d2dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a830d2dc",
  null
  
)

export default component.exports